import { render, staticRenderFns } from "./SignOutPage.vue?vue&type=template&id=0b3fa75c&"
import script from "./SignOutPage.vue?vue&type=script&lang=ts&"
export * from "./SignOutPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports